import React from 'react';
import './styles.less';
import { Header } from 'components/gyramais';

const SandboxScreen = () => (
  <Header />
);

export default SandboxScreen;
